import { AlertTriangle, CheckCircle2, ShieldAlert } from "lucide-react";
import { calibrationTips, getLastMicCheck, micCheckWarning } from "@/lib/micCalibration";

const ago = (iso) => {
  const m = Math.round((Date.now() - new Date(iso)) / 60000);
  return m < 1 ? "just now" : m < 60 ? `${m} min ago` : m < 1440 ? `${Math.round(m / 60)} h ago` : `${Math.round(m / 1440)} day(s) ago`;
};

export const LastMicCheck = ({ compact = false, testId = "last-mic-check" }) => {
  const check = getLastMicCheck();
  if (!check) {
    return compact ? null : <p data-testid={`${testId}-none`} className="rounded-lg bg-slate-100 p-3 text-xs text-slate-600">No saved mic check yet. Run the microphone test below so we can warn you about noise before exams.</p>;
  }
  const warn = micCheckWarning(check);
  if (!warn) {
    if (compact) return null;
    const top = calibrationTips(check.stats).find((t) => t.tone === "good");
    return <p data-testid={`${testId}-ok`} className="flex items-center gap-2 rounded-lg bg-emerald-50 p-3 text-xs text-emerald-800"><CheckCircle2 className="h-4 w-4 shrink-0" />Last mic check {ago(check.date)}: {top?.title || "quiet room and good voice level"}.</p>;
  }
  const bad = warn.level === "bad";
  const Icon = bad ? ShieldAlert : AlertTriangle;
  return (
    <div data-testid={`${testId}-warning`} data-level={warn.level} className={`flex items-start gap-2 rounded-lg border p-3 text-sm ${bad ? "border-rose-300 bg-rose-50 text-rose-800" : "border-amber-300 bg-amber-50 text-amber-800"}`}>
      <Icon className="mt-0.5 h-4 w-4 shrink-0" />
      <div><b>Mic check warning</b> <span className="opacity-70">({ago(check.date)})</span><div className="text-xs">{warn.text}</div></div>
    </div>
  );
};
